import {
  CREATE_WARRANTY_STATUS,
  DELETE_WARRANTY_STATUS,
  EDIT_WARRANTY_STATUS,
  RECEIVE_WARRANTY_STATUSES,
  REQUEST_ALL_WARRANTY_STATUSES,
  REQUEST_WARRANTY_STATUS,
} from '@sophocles/entities/WarrantyStatus/warrantyStatusActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_WARRANTY_STATUSES: // Read
      return state.merge(action.warrantyStatuses);
    case DELETE_WARRANTY_STATUS: // Delete
      return state.delete(action.warrantyStatus.toString());
    case EDIT_WARRANTY_STATUS: // Update
    case CREATE_WARRANTY_STATUS: // Create
    case REQUEST_WARRANTY_STATUS:
    case REQUEST_ALL_WARRANTY_STATUSES:
    default:
      return state;
  }
}

export function warrantyStatusReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_WARRANTY_STATUS:
    case DELETE_WARRANTY_STATUS:
    case RECEIVE_WARRANTY_STATUSES:
    case EDIT_WARRANTY_STATUS:
    case REQUEST_WARRANTY_STATUS:
    case REQUEST_ALL_WARRANTY_STATUSES:
      return getState(state, action);
    default:
      return state;
  }
}
